(() => {
  const update = () => document.querySelectorAll('.rls2 [data-ls-deadline]').forEach(el => {
    const remaining = Math.max(0, Math.floor((Date.parse(el.dataset.lsDeadline) - Date.now()) / 1000));
    if (!Number.isFinite(remaining)) { el.hidden = true; return; }
    const root = el.closest('.rls2');
    root.querySelectorAll('[data-ls-promotion]').forEach(x => { x.hidden = remaining === 0; });
    root.querySelectorAll('[data-ls-standard]').forEach(x => { x.hidden = remaining > 0; });
    const values = [Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60];
    el.querySelectorAll('[data-ls-unit]').forEach((x,i) => { x.textContent = String(values[i]).padStart(2,'0'); });
  });
  update();
  const timer = setInterval(() => { if (!document.querySelector('.rls2')) clearInterval(timer); else update(); },1000);
  document.addEventListener('shopify:section:load',update);
})();
